import * as Tabs from '@radix-ui/react-tabs';
import { Instrument } from './Instrument';
import { Album } from './Album';
import { Poster } from './Poster';
interface UserAccess {
  instrument: boolean;
  album: boolean;
  poster: boolean;
}

interface ValuationFormProps {
  credentials: {
    username: string;
    password: string;
  };
  onAuthError?: () => void;
  dbMode: 'demo' | 'live';
  userAccess?: UserAccess;
}

export function ValuationForm({
  credentials,
  onAuthError,
  dbMode,
  userAccess,
}: ValuationFormProps) {
  return (
    <div className='space-y-6'>
      <Tabs.Root
        defaultValue={
          userAccess?.instrument
            ? 'instrument'
            : userAccess?.album
              ? 'album'
              : userAccess?.poster
                ? 'poster'
                : 'instrument'
        }
        className='mx-auto mt-6 w-full max-w-2xl'
      >
        <Tabs.List className='mb-4 flex border-b'>
          {userAccess?.instrument && (
            <Tabs.Trigger
              value='instrument'
              className='px-4 py-2 font-medium focus:outline-none data-[state=active]:border-b-2 data-[state=active]:border-primary'
            >
              Instrument
            </Tabs.Trigger>
          )}
          {userAccess?.album && (
            <Tabs.Trigger
              value='album'
              className='px-4 py-2 font-medium focus:outline-none data-[state=active]:border-b-2 data-[state=active]:border-primary'
            >
              Album
            </Tabs.Trigger>
          )}
          {userAccess?.poster && (
            <Tabs.Trigger
              value='poster'
              className='px-4 py-2 font-medium focus:outline-none data-[state=active]:border-b-2 data-[state=active]:border-primary'
            >
              Poster
            </Tabs.Trigger>
          )}
        </Tabs.List>
        {userAccess?.instrument && (
          <Tabs.Content value='instrument'>
            <Instrument
              credentials={credentials}
              dbMode={dbMode}
              onAuthError={onAuthError}
            />
          </Tabs.Content>
        )}
        {userAccess?.album && (
          <Tabs.Content value='album'>
            <Album
              credentials={credentials}
              dbMode={dbMode}
              onAuthError={onAuthError}
            />
            {/* legacy album inline UI removed */}
          </Tabs.Content>
        )}
        {userAccess?.poster && (
          <Tabs.Content value='poster'>
            <Poster
              credentials={credentials}
              dbMode={dbMode}
              onAuthError={onAuthError}
            />
          </Tabs.Content>
        )}
      </Tabs.Root>
    </div>
  );
}
